import React from '../../../_snowpack/pkg/react.js';
import styled, { keyframes } from '../../../_snowpack/pkg/styled-components.js';
import { colors } from '../../css/index.js';
const rotateOuter = keyframes(["0%{transform:rotate(0deg);}25%{transform:rotate(180deg);}50%{transform:rotate(180deg);}75%{transform:rotate(360deg);}100%{transform:rotate(360deg);}"]);
const rotateInner = keyframes(["0%{height:0;}25%{height:0;}50%{height:100%;}75%{height:100%;}100%{height:0;}"]);
const Outer = styled.span.withConfig({
  displayName: "loading-icon__Outer",
  componentId: "sc-1afxxm-0"
})(["animation:", " 2s infinite ease;border:", " solid ", ";display:inline-block;height:", ";position:relative;width:", ";"], rotateOuter, p => `${p.borderSize}px`, colors.frostbite, p => `${p.size}px`, p => `${p.size}px`);
const Inner = styled.span.withConfig({
  displayName: "loading-icon__Inner",
  componentId: "sc-1afxxm-1"
})(["animation-delay:0.5s;animation:", " 2s infinite ease-in;background-color:", ";display:block;"], rotateInner, colors.frostbite);

function LoadingIcon(props) {
  const {
    size = 30,
    borderSize = 4
  } = props;
  return /*#__PURE__*/React.createElement(Outer, {
    size: size,
    borderSize: borderSize
  }, /*#__PURE__*/React.createElement(Inner, null));
}

export default LoadingIcon;